import { Injectable } from "@angular/core";

@Injectable()
export class ReviewQuestions {
    students = [
        {
            question: 'Did you complete this course?',
            slug: 'completedCourse',
            points: false,
            answersType: 'trueFalse',
            answers: [
                { answer: 'Yes' },
                { answer: 'No' }
            ]
        },
        {
			question: 'Have you completed 50% of your course?',
            slug: 'completedHalfCourse',
            points: false,
            answersType: 'trueFalse',
            answers: [
                { answer: 'Yes' },
                { answer: 'No' }
            ]
        },
        {
			question: 'I did not complete this course because...',
            slug: 'notCompletedBecause',
            points: false,
            answersType: 'multichoice',
            answers: [
                { answer: 'My personal circumstances changed' },
                { answer: 'I didn\'t enjoy the course' },
                { answer: 'The course was too difficult' },
                { answer: 'I didn\'t feel I was obtaining the skills that I expected to obtain when I enrolled' },
                { answer: 'I had already completed enough subjects to get the knowledge I wanted so I dropped out' },
                { answer: 'My employer did not require me to complete the course because I already had the knowledge needed for the job' },
                {
                    answer: 'I am part way through my course, but not 50% completed, please specify the month and year you will be at 50% course completed',
                    subQuestion: {
                        type: 'month-year',
                        slug: 'notCompletedBecauseStillDoing'
                    }
                },
                {
                    answer: 'Other reason, please specify',
                    subQuestion: {
                        type: 'textField',
                        slug: 'notCompletedBecauseOther',
                        placeholder: 'Please specify'
                    }
                }
            ]
        },
        {
			question: 'Please specify the month and year you completed this course. If only 50% completed please specify the month and year you are due to complete',
            slug: 'completedCourseIn',
            points: false,
            answersType: 'month-year'
        },
        {
            question: 'How was this course delivered?',
            slug: 'howWasCourseDelivered',
            points: false,
            answersType: 'multichoice',
            answers: [
                { answer: 'Online' },
                { answer: 'Face-to-face (i.e.classroom)' },
                { answer: 'Combination of online and face-to-face' },
                { answer: 'As an apprenticeship or traineeship' }
            ]
        },
        {
            question: 'Overall, how easy or difficult did you find the administration procedures of your training provider',
            smallText: '(e.g.enrolment process, access to systems and support, course completion procedures)?',
            slug: 'easeOfAdministrationProcedures',
            points: true,
            answersType: 'multichoice',
            answers: [
                {
                    answer: 'Very easy',
                    points: 4,
                },
                {
                    answer: 'Easy',
                    points: 3,
                },
                {
                    answer: 'Difficult',
                    points: 2,
                },
                {
                    answer: 'Very Difficult',
                    points: 1,
                }
            ]
        },
        {
            question: 'Did this course involve any practical work experience?',
            slug: 'involveAnyPracticalWorkExperience',
            points: true,
            answersType: 'trueFalse',
            answers: [
                {
                    answer: 'No',
                    points: 1
                },
                {
                    answer: 'Yes',
                    points: 2
                }
            ]
        },
        {
            question: 'Who arranged the work experience?',
            slug: 'whoArrangedWork',
            points: true,
            answersType: 'multichoice',
            answers: [
                {
                    answer: 'Was already employed in the industry',
                    points: 1,
                },
                {
                    answer: 'I arranged it myself',
                    points: 2,
                },
                {
                    answer: 'I arranged it myself based on suggestions from my training provider',
                    points: 2,
                },
                {
                    answer: 'My training provider arranged it',
                    points: 4,
                }
            ]
        },
        {
            label: 'To what extent do you agree or disagree with the following statements',
            question: 'The work experience I completed was beneficial to building my skills and knowledge in the industry this course was related to.',
            slug: 'workExperienceWasBeneficial',
            points: true,
            answersType: 'multichoice',
            answers: [
                {
                    answer: 'Strongly agree',
                    points: 4,
                },
                {
                    answer: 'Agree',
                    points: 3,
                },
                {
                    answer: 'Disagree',
                    points: 2,
                },
                {
                    answer: 'Strongly disagree',
                    points: 1,
                }
            ]
        },
        {
            question: 'My course assessments were based on realistic work activities.',
            slug: 'assessmentsBasedOnRealisticActivities',
            points: true,
            answersType: 'multichoice',
            answers: [
                {
                    answer: 'Strongly agree',
                    points: 4,
                },
                {
                    answer: 'Agree',
                    points: 3,
                },
                {
                    answer: 'Disagree',
                    points: 2,
                },
                {
                    answer: 'Strongly disagree',
                    points: 1,
                }
            ]
        },
        {
            question: 'The trainers understood the course content and were knowledgeable about the industry this course was related to.',
            slug: 'trainersWereKnowledgeable',
            points: true,
            answersType: 'multichoice',
            answers: [
                {
                    answer: 'Strongly agree',
                    points: 4,
                },
                {
                    answer: 'Agree',
                    points: 3,
                },
                {
                    answer: 'Disagree',
                    points: 2,
                },
                {
                    answer: 'Strongly disagree',
                    points: 1,
                }
            ]
        },
        {
            question: 'The trainers were responsive and provided support and assistance when I needed it during this course.',
            slug: 'trainersWereResponsive',
            points: true,
            answersType: 'multichoice',
            answers: [
                {
                    answer: 'Strongly agree',
                    points: 4,
                },
                {
                    answer: 'Agree',
                    points: 3,
                },
                {
                    answer: 'Disagree',
                    points: 2,
                },
                {
                    answer: 'Strongly disagree',
                    points: 1,
                }
            ]
        },
        {
            question: 'Which of the following statements best describes your work situation:',
            slug: 'describesYourSituation',
            points: false,
            answersType: 'multichoice',
            answers: [
                { answer: 'I was working in the industry related to my course while studying', },
                { answer: 'I found work related to this course within 3 months of completing the course', },
                { answer: 'I found work related to this course within 3 to 6 months of completing the course', },
                { answer: 'I found work related to this course after 6 months of having completed the course', },
                {
                    answer: 'I\'m still looking for work related to this course',
                    subQuestion: {
                        type: 'textField',
                        slug: 'describesYourSituationStillLooking',
                        placeholder: '',
                        label: 'Approximately how long have you been looking for work?'
                    }
                },
                { answer: 'I\'ve decided to change industry and am not seeking employment related to this course', }
            ]
        },
        {
            question: 'Based on your experience of completing this course, how likely or unlikely are you to recommend your training provider to others?',
            slug: 'howLikelyYouRecommend',
            points: true,
            answersType: 'multichoice',
            answers: [
                {
                    answer: 'Very likely',
                    points: 4,
                },
                {
                    answer: 'Likely',
                    points: 3,
                },
                {
                    answer: 'Unlikely',
                    points: 2,
                },
                {
                    answer: 'Very unlikely',
                    points: 1,
                }
            ]
        }
    ];
    employers = [
        {
            question: 'Did your employee(s) complete this course before you employed them?',
            slug: 'completedCourse',
            points: false,
            answersType: 'multichoice',
            answers: [
                { answer: 'Yes' },
                { answer: 'No, they completed this course while employed in my organisation' },
                { answer: 'My employee(s) did not complete the course' }
            ]
        },
        {
            label: 'To what extent do you agree or disagree with the following statements',
            question: 'Completing this course was beneficial to employee(s) job role: ',
            slug: 'courseWasBeneficialToJobRole',
            points: true,
            answersType: 'multichoice',
            answers: [
                {
                    answer: 'Strongly agree',
                    points: 4,
                },
                {
                    answer: 'Agree',
                    points: 3,
                },
                {
                    answer: 'Disagree',
                    points: 2,
                },
                {
                    answer: 'Strongly disagree',
                    points: 1,
                }
            ]
        },
        {
            question: 'Work-based training in this course was particularly valuable to build their skills and knowledge for the role you hired them for.',
            slug: 'workExperienceWasBeneficial',
            points: true,
            answersType: 'multichoice',
            answers: [
                {
                    answer: 'Strongly agree',
                    points: 4,
                },
                {
                    answer: 'Agree',
                    points: 3,
                },
                {
                    answer: 'Disagree',
                    points: 2,
                },
                {
                    answer: 'Strongly disagree',
                    points: 1,
                },
                {
                    answer: 'Unsure / Don\'t know if they completed work-based training',
                    points: 0,
                }
            ]
        },
        {
            question: 'Did the training provider discuss your requirements and expectations prior to delivering the course?',
            slug: 'trainingProviderDiscussedRequirements',
            points: true,
            answersType: 'trueFalse',
            answers: [
                {
                    answer: 'Yes',
                    points: 4
                },
                {
                    answer: 'No',
                    points: 1
                }
            ]
        },
        {
            label: 'To what extent do you agree or disagree with the following statements',
            question: 'The discussions I had with the training provider ensured the training delivered met my business needs.',
            slug: 'trainingMetBusinessNeeds',
            points: true,
            answersType: 'multichoice',
            answers: [
                {
                    answer: 'Strongly agree',
                    points: 4,
                },
                {
                    answer: 'Agree',
                    points: 3,
                },
                {
                    answer: 'Disagree',
                    points: 2,
                },
                {
                    answer: 'Strongly disagree',
                    points: 1,
                }
            ]
        },
        {
            question: 'The trainer demonstrated a sound understanding of our industry and business needs.',
            slug: 'trainersWereKnowledgeable',
            points: true,
            answersType: 'multichoice',
            answers: [
                {
                    answer: 'Strongly agree',
                    points: 4,
                },
                {
                    answer: 'Agree',
                    points: 3,
                },
                {
                    answer: 'Disagree',
                    points: 2,
                },
                {
                    answer: 'Strongly disagree',
                    points: 1,
                }
            ]
        },
        {
            question: 'The training improved the employee\'s knowledge and skills in areas relevant to the job role?',
            slug: 'trainingImprovedEmployeeKnowledge',
            points: true,
            answersType: 'multichoice',
            answers: [
                {
                    answer: 'Strongly agree',
                    points: 4,
                },
                {
                    answer: 'Agree',
                    points: 3,
                },
                {
                    answer: 'Disagree',
                    points: 2,
                },
                {
                    answer: 'Strongly disagree',
                    points: 1,
                }
            ]
        },
        {
            question: 'The skills and knowledge demonstrated by the employee met your expectations:',
            slug: 'metYourExpectations',
            points: true,
            answersType: 'multichoice',
            answers: [
                {
                    answer: 'Strongly agree',
                    points: 4,
                },
                {
                    answer: 'Agree',
                    points: 3,
                },
                {
                    answer: 'Disagree',
                    points: 2,
                },
                {
                    answer: 'Strongly disagree',
                    points: 1,
                }
            ]
        },
        {
            question: 'If you needed additional staff, how likely or unlikely are you to use this training provider to source skilled potential employees?',
            slug: 'howLikelyYouUseThisTrainingProvider',
            points: true,
            answersType: 'multichoice',
            answers: [
                {
                    answer: 'Very likely',
                    points: 4,
                },
                {
                    answer: 'Likely',
                    points: 3,
                },
                {
                    answer: 'Unlikely',
                    points: 2,
                },
                {
                    answer: 'Very unlikely',
                    points: 1,
                }
            ]
        }
    ];
}



// WEBPACK FOOTER //
// ./src/app/services/review-questions.service.ts